module.exports = __webpack_public_path__ + "static/media/talk.dd174c9c.svg";